import { division } from './admin';


export class sla {
  slaUno?: number;
  strSLAUno?: string;
  slaNameEn?: string;
  slaNameCode?: string;
  slaNameAr?: string;
  reportingDivisionUno?: number;
  reportingAccName?: string;
  slaReference?: string;
  slaTypeUno?: number;
  slaTypeNameEn?: string;
  fSignOffDate?: string;
  signOffDate?: Date;
  businessDivisionUno?: number;
  businessAccNameEn?: string;
  interactionUno?: number;
  interactionNameEn?: string;
  //file
  fileName?: string;
  fileContent?: any[];
  contentType?: string;
  upload: any;
  attachmentCount?: number = 0;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
  icon: string = 'sla';
  type: string = 'sla';
}

export class filecontent {
  userUno?: string;
  masterUNo?: string;
  itemUNo?: string;
  fileName?: string;
  fileContent?: any[];
  contentType?: string;
}
export class kpi {
  kpiUno?: number;
  strKPIUno?: string;
  kpiNameEn?: string;
  kpiNameAr?: string;
  kpiNameCode?: string;
  unitEn?: string;
  unitAr?: string;

  benchMarkable?: boolean;
  benchMarked?: boolean;
  segmented?: boolean;
  kpiTypeUno?: number;
  kpiTypeName?: number;
  inTrack?: boolean;
  formula?: string;
  kpiCode?: string;
  businessDivisionUno?: number;
  businessAccNameEn?: string;
  reportingDivisionUno?: number;
  reportingDivisionName?: string;
  businessDeptUno?: number;
  reportingDeptUno?: number;
  reportingDepartment?: string;
  department?: string;
  divisionName?: string;
  dataOwnerUno?: string;
  dataOwnerName?: string;
  level1ApproverUno?: any;
  level1Approver?: string;
  level2ApproverUno?: any;
  level2Approver?: string;
  level3ApproverUno?: any;
  level3Approver?: string;
  slaUno?: number;
  slaNameEn?: string;
  slaNameAr?: string;
  slaReference?: number;
  interactionUno?: number;
  interactionName?: string;
  trendUno?: number;
  trendName?: string;
  slaRuleUno?: number;
  slaRuleName?: string;
  scheduleUno?: number;
  scheduleName?: string;
  kpiRule?: string;
  targetValue?: number;
  targetUno?: number;
  targetName?: string;
  strategicObjectiveUno?: number;
  strategicObjectiveName?: string;
  leadUno?: number;
  leadName?: string;
  levelUno?: number;
  kpiLevelName?: string;
  accumulationUno?: number;
  accumulationName?: string;
  frequencyUno?: number;
  frequencyName?: string;
  dataEntryUno?: number;
  dataEntryName?: string;
  bmcount?: number;
  dynamicLabel?: string;
  //file
  fileName?: string;
  fileContent?: any[];
  contentType?: string;
  upload: any;
  attachmentCount?: number = 0;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
  icon: string = 'kpi';
  type: string = 'kpi';

  accountability?: string;
  kpiDirection?: string;
  performanceStory?: string;
  futureFocus?: string;
  hasBudget?: boolean;
  ddTypeUno?: number;
  ddType?: string;
}
export class benchmarkkpi {
  kpiUno?: number;
  strKPIUno?: string;
  benchMarkableText?: string;
  benchMarkedText?: string;
  kpiNameEn?: string;
  kpiNameAr?: string;
  kpiNameCode?: string;
  unitEn?: string;
  unitAr?: string;
  benchMarkable?: boolean;
  benchMarked?: boolean;
  segmented?: boolean;
  kpiTypeUno?: number;
  kpiTypeName?: number;
  inTrack?: boolean;
  formula?: string;
  kpiCode?: string;
  businessDivisionUno?: number;
  businessAccNameEn?: string;
  reportingDivisionUno?: number;
  reportingDivisionName?: string;
  businessDeptUno?: number;
  reportingDeptUno?: number;
  reportingDepartment?: string;
  department?: string;
  divisionName?: string;
  dataOwnerUno?: string;
  dataOwnerName?: string;
  level1ApproverUno?: any;
  level1Approver?: string;
  level2ApproverUno?: any;
  level2Approver?: string;
  level3ApproverUno?: any;
  level3Approver?: string;
  slaUno?: number;
  slaNameEn?: string;
  slaNameAr?: string;
  slaReference?: number;
  interactionUno?: number;
  interactionName?: string;
  trendUno?: number;
  trendName?: string;
  slaRuleUno?: number;
  slaRuleName?: string;
  scheduleUno?: number;
  scheduleName?: string;
  kpiRule?: string;
  targetValue?: number;
  targetUno?: number;
  targetName?: string;
  reportingVehicleUno?: number;
  reportingVehicleName?: string;
  performanceStory?: string;
  strategicObjectiveUno?: any;
  strategicObjectiveName?: string;
  strategicPriorityUno?: any;
  strategicPriorityName?: string;
  bmYear?: string;
  leadUno?: number;
  leadName?: string;
  levelUno?: number;
  kpiLevelName?: string;
  accumulationUno?: number;
  accumulationName?: string;
  frequencyUno?: number;
  frequencyName?: string;
  dataEntryUno?: number;
  dataEntryName?: string;
  currentYear?: number;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
  icon: string = 'kpi';
  type: string = 'kpi';
  benchmarkingInsights: string;
  strategicPriority: string;
  isEmail?: number;
  benchmarkEntry?: string;
}
export class benchmarkkpientry {
  BMIncomingUno?: number;
  benchMarkKPIUno?: number;
  xmlValue: string;
  userUno?: string;
  tenantUno?: number;
  condition?: number;
}

export class dashboardContentEntry {
  id?: any;
  itemUno?: any;
  title?: string;
  userUno?: string;
  condition?: number;
  type?: string;
  enteredBy: string;
  enteredOn: string;

}
export class dashboardChart{
  id?: any;
  itemUno?: any;
  userUno?: string;
  condition?: number;
  collectCount?: string;
  analyseCount?: string;
  adaptCount?: string;
  planCount?: string;
  division?: string;
}
export class BMIncomingSurveyEntry {
  bmIncomingUno?: number;
  xmlValue: string;
  userUno?: string;
  condition?: number;
}
export class benchmarkkpiposition {
  trnKPIUno?: number;
  kpiUno?: number;
  year?: number;
  positionUno: number;
  positionName: string;
  userUno?: string;
  condition?: number;
}
export class bmincomingattendees {
  bmIncomingAttendeeUno?: number;
  visitTrackUno?: number;
  firstName: string;
  lastName: string;
  organization: string;
  email: string;
  mobileNumber: string;
  attendance: number;
  feedBack: string;
  condition?: number;
  attendeesCount?: number;
  startedCount?: number;
  completedCount?: number;
  drappedCount?: number;
  completetionCount?: number;
  userUno?: string;
}
export class bmsurveyQAList {
  bmIncomingUno: number;
  question: string;
  questionUno: string;
  options: bmsurveyOptions[];
  userUno?: string;
}

export class bmsurveyOptions {
  optionUno: string;
  optionText: string;
  optionValue: string;
  selectedoptionValue: string;
  count: number;
  percentage: string;
}

export class bmIncomingDashBoard {
  userUno?: string;
  organization: string;
  division: number;
  quarter: number;
  year: number;
  defaultyear: number;
  mostVisitedOrganization: mostVisitedOrganization[];
  mostRequestedTopic: mostRequestedTopic[];
  mostVisitedDivision: mostVisitedDivision[];
  happinessRating: happinessRating[];

  noofDaystoFulfilltheVisit: number;
  noofDaystoConducttheVisit: number;
}
export class bmOutgoingDashBoard {
  userUno?: string;
  organization: string;
  division: number;
  defaultyear: number;
  quarter: number;
  year: number;
  mostVisitedOrganization: mostVisitedOrganization[];
  mostRequestedTopic: mostRequestedTopic[];
  mostVisitedDivision: mostVisitedDivision[];
  happinessRating: happinessRating[];

  noofDaystoFulfilltheVisit: number;
  noofDaystoConducttheVisit: number;
}
export class mostVisitedOrganization {
  noofVisit: number;
  organization: string;
}
export class mostRequestedTopic {
  noofVisit: number;
  requestedTopics: string;
}
export class mostVisitedDivision {
  noofVisit: number;
  divisionNameEn: string;
}

export class happinessRating {
  bmIncomingUno: number;
  organization: string;
  happinessRate: string;
}

export class annualPerformanceBM {
  annualPerformanceBMUno: number;
  divisionUno?: number;
  divisionText?: string;
  departmentUno?: number;  
  departmentText?: string;
  kpiName?: string;
  kpiMeasure?: boolean;
  level?: string;
  benchmarkReason?: string;
  type?: string;
  benchMarkable?: boolean;
  justification?: string;
  userUno?: string;
  condition?: number;
  status?: string;
  tenantUno?: number;
  peerIndustry: string;
  comment: string;
  kpiDefinition: string;
  areaUno: string;
  year1Value: number;
  year1Label: string;
  year2Value: number;
  year2Label: string;
  year3Value: number;
  year3Label: string;
}



export class annualOutingVisit {
  id?: any;
  divisionUno?: number;
  division?: string;
  departmentUno?: number;
  department?: string;
  organization?: string;
  organizationType?: string;
  visitSubject?: string;
  reason?: string;
  visitObjectives?: string;
  expectedVisitDate?: any;
  userUno?: string;
  condition?: number;
  status?: string;
  tenantUno?: number;
  comment: string;
}
export class annualPracticeBM {
  annualPracticeBMUno?: number;
  divisionUno?: number;
  divisionText?: string;
  departmentUno?: number;
  departmentText?: string;
  topic?: string;
  reason?: string;
  kpiMeasure?: boolean;
  strategicObjectives?: string;
  fourG?: boolean;
  expectedOutComes?: string;
  acceptedorNot?: boolean;
  justification?: string;
  userUno?: string;
  condition?: number;
  status?: string;
  tenantUno?: number;
  comment: string;
  targetPeerIndustry?: string;
  description: string;
  areaImprovement: string;
  specificationsRequirements: boolean;
  projectImportance?: string;
  areaUno: string;
  numberOfStrategic: number;
  id: number;
}
export class annualNomination {
  nominationUno?: number;
  annualPerformanceBMUno?: number;
  employeeName?: string;
  prNumber?: string;
  email?: string;
  designation?: string;
  status?: string;
  condition?: number;
  userUno?: string;
  id: number;
  awarenessTitle?: number;
  awarenessTitleUno?: string;
  tenantUno?: number;
}

export class awarenessMaster {
  bmAwarenessTitleUno?: number;
  bmAwarenessTitle?: number;
  awarenessDate?: string;  
  condition?: number;
  userUno?: string;
  id: number;
}
export class bmincoming {
  id?: number;
  visitTrackUno?: number;
  requestFrom?: string;
  visitorFrom?: string;
  organizationType?: string;
  receivedOn?: Date;
  subject?: string;
  requestedTopics?: string;
  concernedDivisionorTeam?: string;
  submittedInSmartDocumentOn?: Date;
  letterStatus?: string;
  letterReferenceNo?: string;
  mdceoResponse?: string;
  officialReplySentOn?: Date;
  replySentTo?: string;
  isDelegatesFilled?: string;
  delegatesFilledOn?: string;
  forwardedtoConcerenedDivisionOn?: Date;
  bmChampionProposedDateOn?: Date;
  delegatesConfirmedOn?: Date;
  logisticsStatus?: string;
  locationorVenue?: string;
  visitRemoteMeetingStatus?: string;
  conductedVisitorRemoteMeetingOn?: Date;
  noofAttendedDelegates?: string;
  satisfactionRate?: any;
  comments?: string;
  status?: string;
  companyName: string;
  yearUno?: number;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  isActive?: boolean;
  xmlData?: string;
  sqUno?: number;
  flag?: string;
  companyLogo?: string;
  fullFillDay?: string;
}


export class bmoutgoing {
  id: number=0;
  visitTrackUno: number=0;
  divisionUno: number;
  division: string;
  department: string;
  departmentUno: number;
  requestedBy: string;
  submittedApprovedVisitForm: string;
  receivedRequestOn: any;
  organizationName: string;
  visitFrom: string;
  organizationType: string;
  purposeorSubject: string;
  submittedSmartDocumentOn: any;
  letterStatusSmartDocument: string;
  referenceNo: string;
  requestStatus: string;
  sentTargetedOrganizationOn: any;
  receivedResponse: string;
  responseFrom: string;
  visitorRemoteMeetingStatus: string;
  visitorRemoteMeetingDate: any;
  submittedAfter: string;
  learntLessons: string;
  capturedBenefits: string;
  isActive: number=1;
  enteredBy: string;
  condition: number = 1;
  comments: string;
  userID: string;
  flag: string;
  tenantUno?: number;
  benchmarkingMeetingStatus: string;
}
export class benchmarkkpirelease {
  benchmarkyear?: number;

  year?: string;
  quarter?: string;
  kpiUno?: number;
  kpiNameEn?: string;
  kpiNameAr?: string;
  kpiCode?: string;

  frequencyUno?: number;
  frequencyName?: string;
  divisionUno?: number;
  divisionName?: string;
  level1ApproverUno?: number;
  level1Approver?: string;
  level2ApproverUno?: string;
  level2Approver?: string;
  level3ApproverUno?: string;
  level3Approver?: string;

  unitEn?: string;
  unitAr?: string;
  formula?: string;
  businessDivisionUno?: number;
  reportingDivisionUno?: number;

  businessDeptUno?: number;
  reportingDeptUno?: number;
  segmented?: boolean;
  benchMarkable?: boolean;
  benchMarked?: boolean;
  kpiTypeUno?: number;
  dataOwnerUno?: string;
  dataOwnerName?: string;
  criteriaUno?: number;
  subCriteria1Uno?: number;
  subCriteria2Uno?: number;
  subCriteria3Uno?: number;
  stgPriorityUno?: number;
  stgPerspectiveUno?: number;
  stgObjectiveUno?: number;
  deptObjectiveUno?: number;
  trendUno?: number;
  trendName?: string;
  targetUno?: number;
  targetName?: string;
  positionUno?: number;
  scheduleUno?: number;
  scheduleName?: string;
  kpiYear?: number;
  kpiQuarter?: number;
  kpiMonth?: number;
  kpiSemiAnnual?: number;
  targetValue?: number;
  isEntered?: number;
  enteredTargetValue?: number = 0;
  kpiAlignment?: string;

  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  slakpiYearUno?: string;
  statusUno?: number;
  lastStatusUno?: number;

  resetComment: string = '';
  resetType: string;
  objkpiRelease: kpiRelease[] = [];
  xmlValue: string = '';
  xmlKPIResetValue: string = '';
  xmlNotificationValue: string = '';
  kpiType?: number;
  currentMonth?: number;
  currentQuarter?: number;
  waitingForReleaseCount?: number;
  inProgressCount?: number;
  completedCount?: number;
  dataOwnerActionByUno?: number = 0;
  level1Approved?: number = 0;
  level2Approved?: number = 0;
  level3Approved?: number = 0;
  period: string = '';
  kpiTrnUno?: number = 0;
  isYearlyReleased?: number = 0;
  bandValueExist?: number = 0;
  withoutMappingCount: string = '';
  rowType: string = '';
  kpiRule?: string;
  strKPIYearUno: string = '';
  count?: number;
  benchMarkEntry?: number;
}
export class bmKPIPerformanceTrend {
  userUno?: string;
  kpiUno?: number = 0;
  benchmarkYear?: string;
  targetValue?: string;
  actualValue?: string;
}
export class tranbenchmarkkpi {
  trnBenchmarkUno?: number;

  id?: number;
  benchmarkYear?: string;
  targetValue?: string;
  kpiUno?: number;
  kpiNameEn?: string;
  kpiNameAr?: string;
  sourceUno?: string;
  sourceName?: string;
  peerUno?: string;
  peerName?: string;
  benchmarks?: string;
  constraints?: string;
  filter?: string;
  formula?: string;
  considerationUno?: string;
  considerationName?: string;
  peerTypeUno?: number;
  peerTypeName?: string;
  continentUno?: number;
  continentName?: string;
  countryUno?: number;
  countryName?: string;
  regionUno?: number;
  regionName?: string;
  utilityTypeUno?: number;
  utilityTypeName?: string;
  sourceTypeUno?: number;
  sourceTypeName?: string;
  positionUno?: number;
  positionName?: string;
  showDataPoint?: boolean;
  isRelease?: boolean;

  dataOwnerUno?: string;
  dataOwner?: string;
  level1ApproverUno?: string;
  level1Approver?: string;
  level2ApproverUno?: string;
  level2Approver?: string;
  level3ApproverUno?: string;
  level3Approver?: string;
  level1Approved?: number;
  level1Rejected?: number;
  level1ApprovedByUno?: number;
  level1ApprovedBy?: string = '';
  level1ApprovedOn?: string;
  level1RejectedByUno?: number;
  level1RejectedBy?: string = '';
  level1RejectedOn?: string;
  level2Approved?: number;
  level2Rejected?: number;
  level2ApprovedByUno?: number;
  level2ApprovedBy?: string;
  level2ApprovedByImage?: string;
  level2ApprovedOn?: string;
  level2RejectedByUno?: number;
  level2RejectedBy?: string;
  level2RejectedOn?: string;
  level3Approved?: number;
  level3Rejected?: number;
  level3ApprovedByUno?: number;
  level3ApprovedBy?: string;
  level3ApprovedByImage?: string;
  level3ApprovedOn?: string;
  level3RejectedByUno?: number;
  level3RejectedBy?: string;
  level3RejectedOn?: string;
  statusUno?: number;
  actualValue?: any;
  comments: string;
  divisionUno?: number;
  kpiType?: number;
  isAdmin?: boolean;
  filterDataCollectionCount?: number;
  filterCompletedCount?: number;
  filterApprovalCount?: number;

  dataRleaseUno?: number;
  dataRleasedBy?: string;
  dataRleasedByImage?: string;
  dataRleasedOn?: string;

  dataOwnerComments?: string;
  dataOwnerActionByUno?: number;
  dataOwnerActionBy?: string;
  dataOwnerActionOn?: string;
  dataOwnerActionByImage?: string;
  xmlData?: string;

  performanceStory?: string;
  benchmarkingInsights?: string;
  strategicPriority?: string;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: any;
  actionType: string;
  icon: string = 'kpi';
  type: string = 'kpi';

}
export class recentUpdates {
  id?: number;
  enteredBy?: string;
  enteredOn?: string;
  modifiedOn?: string;
  modifiedBy?: string;
  title?: string;
  description?: string;
  userUno?: string;
  condition?: number;
  languageUno?: number;

}
export class tranbenchmarkkpihistory {
  userUno?: string;
  kpiTrnUno?: number;
  action?: string;
  enteredBy?: string;
  enteredByImage?: string;
  enteredDate?: string;
  comments?: string;
  itemUno?: number;
  condition?: number;

}
export class practicebmtransactionadd
{
  id?: number;
  projectName?: string;
  projectMemberName?: string;
  divisionUno?: number;
  division?: string;
  projectManagerUno?: number;
  projectManager?: string;
  bmChampions?: string;
  bmProgressUno?: any;
  peerUno?: number;
  peer?: string;
  plannedStartDate?: Date;
  plannedEndDate?: Date;
  comments?: string;
  enteredBy?: string;
  enteredDate?: string;
  userUno?: string;
  itemUno?: number;
  condition?: number;
  languageUno?: number;
  tenantUno?: number;
  projectUno?: any;
  bmProgressItemUno?: any;
  bmProgressName?: any;
  percentage?: number;
  status?: string;
  projectMember?: any;
  level1ApproverUno?: any;
  level2ApproverUno?: any;
  level3ApproverUno?: any;
  firstAssingedApproversName?: any;
  secondAssingedApproversName?: any;
  thirdAssingedApproversName?: any;
  corporateStrategic?: any;
  percentageActual?: number;
  percentageTarget?: number;
  attachementCount?: number;
  flag?: any;
}


export class practiceBMGranttChart {
  id?: number;
  projectUno?: any;
  taskName?: any;
  resource?: any;
  duration?: any;
  actual?: number;
  target?: any;
  percentComplete?: any;
  progressType?: any;
  progresStatus?: any;
  startDate?: any;
  endDate?: any;
  userUno?: string;
}
export class BMProjectActions {
  id?: number;
  userUno?: string;
  itemUno?: number;
  condition?: number;
  languageUno?: number;
  tenantUno?: number;
  projectUno?: any;
  bmProgressItemUno?: any;
  bmProgressName?: any;
  progressStatus?: any;
  percentage?: number;
  percentageTarget?: string;
  bmProgressUno?: any;
  assignedUser?: any;
  percentageActual?: any;
  updatedOn?: any;
  enteredBy?: any;
  assignedUserName?: any;
  startDate?: any;
  endDate?: any;
  status?: any;
  comments?: any;
}

export class BMProjectApprovalHistroy {
  id?: number;
  userUno?: string;
  itemUno?: number;
  condition?: number;
  languageUno?: number;
  tenantUno?: number;
  projectUno?: any;
  projectName?: string;
  approverName?: any;
  enteredBy?: any;
  enteredOn?: any;
  status?: any;
  comments?: any;
  firstApprovedName?: string;
  secondApprovedName?: string;
  thirdApprovedName?: string;
  firstApprovedDate?: string;
  secondApprovedDate?: string;
  thirdApprovedDate?: string;
}

export class BMProjectActionsHistory {
  id?: number;
  progress?: number=0;
  userUno?: string;
  itemUno?: number;
  condition?: number;
  languageUno?: number;
  tenantUno?: number;
  actionTrnUno?: number;
  projectUno?: any;
  fileName?: any;
  fileContent?: any;
  contentType?: any;
  comments?: any;
  actionType?: any;
  actionText?: any;
  actionStatus?: any;
  enteredDate?: any;
  nextUpdate?: any;
  remarks?: any;
  bmProgressUno?: any;
  percentageActual?: number;
  filePath?: string;
  projectName?: any;
  projectManager?: any;
  projectManagerUno?: any;
  projectNextLevelUserUno?: any;
  taskName?: any;
  actionby?: any;
  target?: any;
  actual?: any;
  status?: any;
  enteredBy?: string;
}
export class user {
  displayText?: string;
  userUno?: string;
  tenantUno?: number;
  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
}


export class slaInteraction {
  slaInteractionUno?: number;
  interactionUno?: number;
  slaUno?: number;
  userUno?: string;
  tenantUno?: number;
  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  objslaInteraction: slaInteraction[] = [];
}

export class kpiInteraction {
  interactionTrnUno?: number;
  interactionUno?: number;
  kpiUno?: number;
  userUno?: string;
  tenantUno?: number;
  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  objkpiInteraction: kpiInteraction[] = [];
}

export class slakpiInteraction {
  uno?: string;
  puno?: string;
  name?: string;
  icon?: string;
  type?: string;
  expanded?: boolean;
  hasChild?: boolean;
  userUno?: string;
  tenantUno?: number;
  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  quaterFilter: number;
  yearFilter: number;
  kpiFilter: number = 0;
  yearFilterDefault: number;
  dragItem?: boolean;
  nodedroppedQuater: number = 1;
  nodedroppedYear: number = 1;

}
export class slakpiMapping {
  slakpiyearUno?: number;
  slayear?: number;
  slaquarter?: number;
  slaUno?: number;
  kpiUno?: number;
  kpinameEn?: string;
  userUno?: string;
  tenantUno?: number;
  draggedslayear?: number;
  draggedslaquarter?: number;
  draggedslaUno?: number;
  draggedkpiUno?: number;
  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  uno?: string;
 kpiyear?: number;
  kpiquarter?: number;
  objslakpiInteraction: slakpiMapping[] = [];
}
export class year {
  displayText?: string;
  value?: number;
  userUno?: string;
  tenantUno?: number;
  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
}
export class bmdashboardFilterValue {
  yearuno?: number;
  peeruno?: number;
  businessDivisionUno?: number;
  businessDeptUno?: number;
  trendUno?: number;
  positionUno?: number;
  sourceUno?: number;
  considerationUno?: number;
  //filter  
  userUno?: string;
  kpiuno?: number;
  strKPIUno?: string;
  strPeerUno?: string;
  strYearUno?: string;
  strFilter?: string;
  strOrder?: string;
}

export class bmKPIPostionDashboard {
  year?: number;
  businessDivisionUno?: number;
  businessDeptUno?: number;
  targetValue?: string;
  actualValue?: string;
  peerName?: string;
  //filter  
  userUno?: string;
  kpiuno?: number;
}


export class quater {
  displayText?: string;
  value?: number;
  userUno?: string;
  tenantUno?: number;
  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
}
export class kpiRelease {
  slayear?: number;
  slaquarter?: number;
  year?: string;
  quarter?: string;
  kpiUno?: number;
  kpiNameEn?: string;
  kpiNameAr?: string;
  kpiCode?: string;
  slaUno?: number;
  slaRuleUno?: number;
  slaRuleName?: string;
  slaNameEn?: string;
  slaNameAr?: string;
  frequencyUno?: number;
  frequencyName?: string;
  divisionUno?: number;
  divisionName?: string;
  level1ApproverUno?: number;
  level1Approver?: string;
  level2ApproverUno?: string;
  level2Approver?: string;
  level3ApproverUno?: string;
  level3Approver?: string;

  unitEn?: string;
  unitAr?: string;
  formula?: string;
  businessDivisionUno?: number;
  reportingDivisionUno?: number;

  businessDeptUno?: number;
  reportingDeptUno?: number;
  segmented?: boolean;
  benchMarkable?: boolean;
  benchMarked?: boolean;
  kpiTypeUno?: number;
  dataOwnerUno?: string;
  dataOwnerName?: string;
  criteriaUno?: number;
  subCriteria1Uno?: number;
  subCriteria2Uno?: number;
  subCriteria3Uno?: number;
  stgPriorityUno?: number;
  stgPerspectiveUno?: number;
  stgObjectiveUno?: number;
  deptObjectiveUno?: number;
  trendUno?: number;
  targetUno?: number;
  targetName?: string;
  positionUno?: number;
  scheduleUno?: number;
  scheduleName?: string;
  kpiYear?: number;
  kpiQuarter?: number;
  kpiMonth?: number;
  kpiSemiAnnual?: number;
  targetValue?: number;
  enteredTargetValue?: number = 0;
  kpiAlignment?: string;

  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  slakpiYearUno?: string;
  statusUno?: number;
  lastStatusUno?: number;

  resetComment: string = '';
  resetType: string;
  objkpiRelease: kpiRelease[] = [];
  xmlValue: string = '';
  xmlKPIResetValue: string = '';
  xmlNotificationValue: string = '';
  currentHalf?: number;
  currentMonth?: number;
  currentQuarter?: number;
  waitingForReleaseCount?: number;
  inProgressCount?: number;
  completedCount?: number;
  dataOwnerActionByUno?: number = 0;
  level1Approved?: number = 0;
  level2Approved?: number = 0;
  level3Approved?: number = 0;
  period: string = '';
  kpiTrnUno?: number = 0;
  isYearlyReleased?: number = 0;
  bandValueExist?: number = 0;
  withoutMappingCount: string = '';
  rowType: string = '';
  strKPIYearUno: string = '';
}

export class kpiReset {
  kpiTrnUno?: number = 0;
  tenantUno?: number;
  dataOwnerActionByUno?: number = 0;
  level1Approved?: number = 0;
  level2Approved?: number = 0;
  level3Approved?: number = 0;
  userUno?: string = '';
  resetComment: string = '';
  resetType: string = '';
  kpiUno: number;
  slakpiYearUno?: string;
  objkpiReset: kpiReset[] = [];
}

export class slaperformance {

  kpiUno?: number;
  kpiName?: string;
  kpiyear?: number;
  kpiquarter?: number;
  year?: string;
  quarter?: string;
  slaUno?: number;
  slaName?: string;
  divisionUno?: number;
  divisionName?: string;

  slaReference?: string;
  slaPerfomancePercentage?: string;
  statusName?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;

  frequencyUno?: number;
  frequencyName?: string;
  month?: number;
  half?: number;
  bandValue?: number;
  bandValueText?: string;
  slaRuleUno?: number;
  type?: string;
  wellperformKPIRange?: number;
  firstParty?: string;  
  secondParty?: string;
  noOfKPI?: string;
  noOfEvaluatedKPI?: string;
  reporting?: string;
}



export class slakpiperformance {
  emailId?: string;
  kpiUno?: number;
  kpiName?: string;
  kpiCode?: string;
  slaUno?: number;
  slaName?: string;
  kpiyear?: number;
  kpiquarter?: number;
  year?: string;
  quarter?: string;
  divisionUno?: number;
  divisionName?: string;
  actualValue?: number;
  targetValue?: number;
  slaRuleUno?: number;
  type?: string;
  statusName?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  frequencyUno?: number;
  frequencyName?: string;
  month?: number;
  half?: number;
  bandValue?: number;
  bandValueText?: string;
  wellperformKPIRange?: number;
  targetValueText: string = '';
  actualValueText: string = '';
  kpiRule?: string;
  kpiyearTo?: string = '';
}

export class slaIssueList {

  kpiUno?: number;
  kpiTrnUno?: number;
  kpiTrnIssueUno?: number;
  kpiName?: string;
  kpiCode?: string;
  slaUno?: number;
  slaName?: string;
  kpiyear?: number;
  kpiquarter?: number;
  year?: string;
  quarter?: string;
  currentYear?: number;
  currentQuarter?: number;
  currentHalf?: number;
  currentMonth?: number;
  divisionUno?: number;
  businessDivisionUno?: number;
  reportingDivisionUno?: number;
  divisionName?: string;
  actualValue?: number;
  targetValue?: number;
  slaRuleUno?: number;
  type?: string;
  statusName?: string;
  issueStatus?: string;
  issue?: string;
  owner?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  frequencyUno?: number;
  frequencyName?: string;
  month?: number;
  half?: number;
  bandValue?: string;
  issueStatusUno?: number;
  issueDescription?: string;
  periodDisplay?: string;
  postedBy?: string;
  postedByImage?: string;
  postedDate?: string;
  comment?: string;
  startIndex?: number;
  maxCount?: number;
}

export class slakpidatabase {

  kpiUno?: number;
  kpiName?: string;
  kpiCode?: string;
  kpiTrnUno?: number;
  slaUno?: number;
  slaName?: string;
  kpiyear?: number;
  kpiquarter?: number;
  year?: string;
  quarter?: string;
  divisionUno?: number;
  divisionName?: string;
  actualValue?: number;
  targetValue?: number;
  slaRuleUno?: number;
  type?: string;
  statusName?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  frequencyUno?: number;
  frequencyName?: string;
  month?: number;
  half?: number;
  bandValue?: number;
  bandColour?: string;
  approver1Exists?: number;
  approver2Exists?: number;
  approver3Exists?: number;
  dataOwnerExists?: number;
  dataOwnerActionByUno?: number;
  level1Approved?: number;
  level2Approved?: number;
  level3Approved?: number;
  level1ApproverUno?: string;
  level2ApproverUno?: string;
  level3ApproverUno?: string;
  dataOwnerUno?: string;
  level1Approver?: string;
  level2Approver?: string;
  level3Approver?: string;
  dataOwner?: string;
  comment?: string;
  bandValueText?: string;
  isNANRNT?: string = '';
  currentStage?: string;
  targetValueText: string = '';
  actualValueText: string = '';
  kpiRule?: string;

}

export class kpitarget {
  trnSLAKPI?: string;
  kpiUno?: number;
  defaultYear: number;
  kpiYear?: number;
  kpiYear_Text?: string;
  frequency?: number;
  kpitarget1?: number;
  kpitarget2?: number;
  kpitarget3?: number;
  kpitarget4?: number;
  kpitarget5?: number;
  kpitarget6?: number;
  kpitarget7?: number;
  kpitarget8?: number;
  kpitarget9?: number;
  kpitarget10?: number;
  kpitarget11?: number;
  kpitarget12?: number;
  kpitarget13?: number;
  scheduleUno?: number;
  isActive?: number;
  enteredBy?: number;
  xmlValue?: string;
  userUno?: string;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  listkpiTarget: kpitarget[] = [];
  tenantUno: number;
  foreCastType: number;
}
export class kpiband {
  kpiUno?: number;
  defaultYear: number;
  defaultQuater: number;
  defaultMonth: number;
  defaultSemiYear: number;
  kpiYear?: number;
  kpiYear_Text?: string;
  rule?: number;
  bandtype?: number;
  band1Condition1?: number;
  band1Condition2?: number;
  band1Condition1Text?: string;

  band1Value1?: number;
  band1Value2?: number;
  band1wellperform?: boolean = false;

  band2Condition1?: number;
  band2Condition2?: number;
  band2Condition1Text?: string;
  band2Value1?: number;
  band2Value2?: number;
  band2wellperform?: boolean = false;

  band3Condition1?: number;
  band3Condition2?: number;
  band3Value1?: number;
  band3Value2?: number;
  band3wellperform?: boolean = false;

  band4Condition1?: number;
  band4Condition2?: number;
  band4Value1?: number;
  band4Value2?: number;
  band4wellperform?: boolean = false;

  band5Condition1?: number;
  band5Condition2?: number;
  band5Value1?: number;
  band5Value2?: number;
  band5wellperform?: boolean = false;
  isError?: boolean = false;

  scheduleUno?: number;
  isActive?: number;
  enteredBy?: number;
  xmlValue?: string;
  userUno?: string;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  tenantUno?: number;
  listkpiBand: kpiband[] = [];
  scheduleTypeUno?: number = 0;
}
export class kpiWithTarget {
  kpiUno?: number;
  kpiNameEn?: string;
  kpiNameAr?: string;
  kpiCode?: string;
  scheduleUno?: number;
  kpiYear?: number;
  kpiQuarter?: number;
  targetValue?: number;
  slaRuleUno?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  reportingDivisionName?: string;
  slaRuleName?: string;
  scheduleName?: string;
  scheduleTypeUno?: number = 0;
}
export class kpiDynamic {
  kpiTrnUno?: number;
  kpiUno?: number;
  kpiDynamicLabel?: string;
  kpiDynamicValue?: string;
  fileName?: string;
  filePath?: string;
  year?: number;
  quarter?: number;
  userUno?: string;
  tenantUno?: number;
  AttachmentUno?: number;
  languageUno?: number;
}
export class kpiInbox {
  kpiTrnUno?: number;
  kpiUno?: number;
  kpiRefNo?: string;
  startDate?: string;
  endDate?: string;
  kpiNameEn?: string;
  kpiNameAr?: string;
  kpiCode?: string;
  dynamicLabel?: string;
  level1ApproverUno?: string;
  level1Approver?: string;
  level2ApproverUno?: string;
  level2Approver?: string;
  level3ApproverUno?: string;
  level3Approver?: string;
  businessDivisionUno?: number;
  businessDivision?: string;
  reportingDivisionUno?: number;
  reportingDivision?: string;
  businessDeptUno?: number;
  businessDept?: string;
  reportingDeptUno?: number;
  reportingDept?: string;
  kpiTypeUno?: number;
  dataOwnerUno?: string;
  dataOwner?: string;
  targetValue?: number;
  actualTargetValue?: number;
  scheduleUno?: number;
  isNANRNT?: string = '';
  kpiYear?: number;
  kpiQuarter?: number;
  kpiYearName?: string;
  kpiQuarterName?: string;
  kpiMonth?: number;
  kpiSemiAnnual?: number;
  slakpiYearUno?: number;
  slaUno?: number;
  slaName?: string;
  slaRuleUno?: number;
  slaRuleName?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;

  statusUno?: number;
  lastStatusUno?: number;
  formula?: string;

  slaRule?: string;
  schedule?: string;
  trend?: string;
  trendUno?: string;
  unit?: string;

  deadLine?: string;
  actualValue?: string;
  period?: string;
  periodDisplay?: string;
  status?: string;
  dataRleaseUno?: number;
  dataRleasedBy?: string;
  dataRleasedByImage?: string;
  dataRleasedOn?: string;

  dataOwnerComments?: string;
  dataOwnerActionByUno?: number;
  dataOwnerActionBy?: string;
  dataOwnerActionOn?: string;
  dataOwnerActionByImage?: string;
  level1Approved?: number;
  level1Rejected?: number;
  level1ApprovedByUno?: number;
  level1ApprovedBy?: string = '';
  level1ApprovedOn?: string;
  level1ApprovedByImage?: string;
  level1RejectedByUno?: number;
  level1RejectedBy?: string = '';
  level1RejectedOn?: string;
  level2Approved?: number;
  level2Rejected?: number;
  level2ApprovedByUno?: number;
  level2ApprovedBy?: string;
  level2ApprovedByImage?: string;
  level2ApprovedOn?: string;
  level2RejectedByUno?: number;
  level2RejectedBy?: string;
  level2RejectedOn?: string;
  level3Approved?: number;
  level3Rejected?: number;
  level3ApprovedByUno?: number;
  level3ApprovedBy?: string;
  level3ApprovedByImage?: string;
  level3ApprovedOn?: string;
  level3RejectedByUno?: number;
  level3RejectedBy?: string;
  level3RejectedOn?: string;

  approver1Exists?: number;
  approver2Exists?: number;
  approver3Exists?: number;
  dataOwnerExists?: number;
  bandValue?: number;
  bandColour?: string;
  bandValueText?: string;
  scheduleText?: string;
  currentStage?: string;
  targetPercentage?: number;
  passFail?: string;

  currentLevel?: string;
  isCurrentLevelUser?: boolean;
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;

  filterDataCollection?: number;
  filterOverdue?: number;
  filterCompleted?: number;
  filterApproval?: number;
  filterDataCollectionCount?: number;
  filterOverdueCount?: number;
  filterCompletedCount?: number;
  filterApprovalCount?: number;
  filterColor?: string;
  isAdmin?: boolean;
  commentCount?: number = 0;
  objkpiInbox: kpiInbox[] = [];
  bandScheduleTypeUno?: number;
  targetValueText: string = '';
  actualValueText: string = '';
  justificationText: string = '';
  kpiRule?: string;

  accountability?: string;
  kpiDirection?: string;
  performanceStory?: string;
  futureFocus?: string;
  isYTD?: number;
}

export class kpiViewComment {
  kpiTrnCommentUno?: number;
  kpiTrnUno?: number;
  postedBy?: string;
  postedByImage?: string;
  postedDate?: string;
  comment?: string;
  action?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  startIndex?: number;
  maxCount?: number;
}

export class kpiViewWorkFlow {

  kpiTrnUno?: number;
  kpiUno?: number;
  issueUno?: number;
  issueStatusUno?: number;
  passFail?: string;
  postedBy?: string;
  postedByImage?: string;
  postedDate?: string;
  comment?: string;
  justification?: string;
  action?: string;
  actionType?: string;
  selectedNANR?: string;
  targetEnteredValue: number;
  userUno?: string;
  tenantUno?: number;
  bandColorFinal?: string = '';
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  startIndex?: number;
  maxCount?: number;
  isWellPerformed?: number;
  level1ApproverUno?: string;
  level2ApproverUno?: string;
  level3ApproverUno?: string;
  dataOwnerUno?: string;
  kpiYear?: number;
  kpiQuarter?: number;
  slaRuleUno?: number;
  kpiNameEn?: string;
  kpiYearName?: string;
  kpiQuarterName?: string;
  scheduleUno?: number;
  kpiMonth?: number;
  kpiSemiAnnual?: number;
  targetValue?: number;
  actualTargetValue?: number;
  objkpiViewWorkflow: kpiViewWorkFlow[] = [];
  objkpiViewWorkflowStatic: kpiViewWorkFlow[];
  saveAction?: string;
  targetValueText: string = '';
  actualValueText: string = '';
  isNANRNT?: string = '';
  xmlValue: string = '';
}
export class kpiViewHistory {
  trnHistoryUno?: number;
  kpiUno?: number;
  enteredBy?: string;
  enteredByImage?: string;
  enteredDate?: string;
  comment?: string;
  action?: string;
  resetType?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  startIndex?: number;
  maxCount?: number;
}
export class kpiNotification {
  notifyUno?: number;
  kpiUno?: number;
  kpiTrnUno?: number;
  kpiName?: string;
  year?: string;
  quater?: string;
  enteredBy?: string;
  enteredDate?: string;
  description?: string;
  notificationType?: string;
  isVisited?: number;
  userUno?: string;
  userName?: string;
  userPhoto?: string;
  tenantUno?: number;
  languageUno?: number;
  condition?: number;
  startIndex?: number;
  maxCount?: number;
  notifyCount?: number;
}

export class kpiUserActivities {

  kpiUno?: number;
  postedBy?: string;
  postedByImage?: string;
  postedDate?: string;
  comment?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  startIndex?: number;
  maxCount?: number;
}


export class kpiViewDashBoard {
  condition?: number;
  slaRuleName?: string;
  scheduleName?: string;
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  slaUno?: number;
  frequencyUno?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  reportingDivisionUno?: number;
  reportingDivisionName?: string;
  wellperformKPIRange?: number;
  wellPerformedRangeorVarianceKPICount?: number;
  underPerformedRangeorVarianceKPICount?: number;
  naRangeorVarianceKPICount?: number;
  wellPerformedTargetKPICount?: number;
  underPerformedTargetKPICount?: number;
  naTargetKPICount?: number;
  wellPerformedTextKPICount?: number;
  underPerformedTextKPICount?: number;
  naTextKPICount?: number;
  underPerformedDivsionwiseKPICount?: number;
  //for SLAKPI
  wellperformSLARange?: number;
  wellPerformedRangeorVarianceSLACount?: number;
  underPerformedRangeorVarianceSLACount?: number;
  naRangeorVarianceSLACount?: number;
  wellPerformedTargetSLACount?: number;
  underPerformedTargetSLACount?: number;
  naTargetSLACount?: number;
  wellPerformedTextSLACount?: number;
  underPerformedTextSLACount?: number;
  naTextSLACount?: number;
  underPerformedDivsionwiseSLACount?: number;

  //for report
  noOfSLAKPICount?: number;
  noOfReleasedKPICount?: number;
  noOfKPICompletedDataEntryStageCount?: number;
  noOfKPIReportedAsNACount?: number;
  noOfKPICompletedByStage1Count?: number;
  noOfKPICompletedByStage2Count?: number;
  noOfKPICompletedByStage3Count?: number;
  wellPerformedSLAKPICount?: number;
  underPerformedSLAKPICount?: number;
  reportUnderperformingCount?: number;
  reportUnderperformingCountString?: string;

  list_KPIViewDashBoardList: kpiViewDashBoard[] = [];
  dashboardType: string;
  list_SLAWPChartList: slaWPChart[] = [];

}

export class performanceDashBoard {
  noOfSLACount?: number;
  noOfReportedSLACount?: number;
  noOfWellPerformedSLACount?: number;
  noOfUnderPerformedSLACount?: number;
  noOfKPICount?: number;
  noOfReportedKPICount?: number;
  noOfWellPerformedKPICount?: number;
  noOfUnderPerformedKPICount?: number;
  noOfNAKPICount?: number;
  reportingKPICount?: number;
  condition?: number;
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  slaUno?: number;
  frequencyUno?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  divisionUno?: number;
  dashboardType: string;
  pageType: string;
  list_SLAWPChartList: slaWPChart[] = [];
  list_KPIWPChartList: kpiWPChart[] = [];
}
export class slaWPChart {
  year?: string;
  totalCount?: number;
}

export class kpiWPChart {
  year?: string;
  actualValue?: string;
  targetValue?: string;
}

export class slakpiMappingArchive {
  userUno?: string;
  slayear?: number;
  slaquarter?: number;
  slaUno?: number;
  kpiUno?: number;
  destSLAYear?: number;
  destSLAQuarter?: number;
  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  tenantUno?: number;

}
export class kpiBulkCopy {
  userUno?: string;
  yearFrom?: number;
  yearTo?: number;
  source?: string;
  target?: string;
  frequency?: string;
  tenantUno?: number;
}
export class surveyOptionMaster {
  id?: number;
  optionUno?: number;
  optionTitle?: string;
  optionValue?: string;
  surveyOptionKey?: string;
  surveyOptionValue?: string;
  imageURL?: string;
  itemUno?: number;
  condition?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
}

export class surveyOptionEntry {
  id?: number;
  optionUno?: number;
  surveyOptionKey?: string;
  surveyOptionValue?: string;
  imageURL?: string;
  itemUno?: number;
  condition?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  xmlValue: string;
}
export class delegatesHappinessMaster {
  id?: number;
  year?: number;
  actual?: string;
  target?: number;
  condition?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
}
export class surveyQuestionMaster {
  id?: number;
  sqUno?: number;
  surveyTitle?: string;
  itemUno?: number;
  condition?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
}


export class surveyQuestionEntry {
  id?: number;
  sqUno?: number;
  surveyName?: string;
  surveyOptionUno?: number;
  surveyOptionTitle?: string;
  itemUno?: number;
  condition?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  xmlValue: string;
}
export class bmsurveyQuestion {
  id?: number;
  bmIncomingUno?: number;
  sqUno?: number;
  surveyTitle?: string;
  itemUno?: number;
  condition?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  xmlValue: string;

}

  export class outgoingBMRequest {
  id?: number;
    incidentNo?: any;
    prNumber?: any;
    division?: any;
    divisionUno?: string;
    department?: string;
    departmentUno?: any;
    bmChampion?: string;
    entityCategory?: string;
    entityType?: string;
    entity?: string;
    contactDetails?: string;
    justification?: string;
    bmSubject?: string;
    purpose?: string;
    reqName?: string;
    designation?: string;
    teamLeader?: string;
    mobileno?: string;
    ownerPRNumber?: any;
    status?: string;
    enteredBy?: any;
    enteredOn?: any;
    userUno?: any;
    condition?: any;
    languageUno?: any;
    tenantUno?: any;
}

export class bmRequest {
  id?: number;
  incidentNo?: any;
  prNumber?: any;
  topic?: any;
  typeDescr?: string;
  reasonforBMSel?: string;
  impactArea?: any;
  targetPeerGeoArea?: string;
  targetBMIndtry?: string;
  expectedOutcomes?: string;
  comments?: string;
  ownerPRNumber?: any;
  status?: string;
  enteredBy?: any;
  enteredOn?: any;
  userUno?: any;
  condition?: any;
  languageUno?: any;
  tenantUno?: any;
}

export class bmRequestStatusHistroy {
  id?: number;
  reqNo?: any;
  comments?: string;
  status?: string;
  enteredBy?: any;
  createdBy?: any;
  enteredOn?: any;
  userUno?: any;
  flag?: any;
  languageUno?: any;
  tenantUno?: any;
}
export class annualStatusHistroy {
  id?: number;
  itemUno?: any;
  comments?: string;
  status?: string;
  enteredBy?: any;
  createdBy?: any;
  enteredOn?: any;
  userUno?: any;
  flag?: any;
  tenantUno?: number;
  languageUno?: any;
}

export class bmInOutGoingStatusHistroy {
  id?: number;
  visitTrackUno?: any;
  comments?: string;
  status?: string;
  enteredBy?: any;
  createdBy?: any;
  enteredOn?: any;
  userUno?: any;
  flag?: any;
  languageUno?: any;
}
export class incomingBMRequest {
  id?: number;
  incidentNo?: any;
  prNumber?: any;
  kpiName?: any;
  kpiDescr?: string;
  kpiFormula?: string;
  kpiRepVehicle?: any;
  targetGeoArea?: string;
  reasonforKPISelection?: string;
  ownerPRNumber?: any;
  status?: string;
  enteredBy?: any;
  enteredOn?: any;
  userUno?: any;
  condition?: any;
  languageUno?: any;
}

export class kpiDashboard_MoroDigitalInfra {
  userUno?: string;
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  reportingDivision?: number;
  targetPercentage?: number;
  tenantUno?: number;
  dashboardType?: string;
  listRevenue: overAllPerformance[];
  listProfit: overAllPerformance[];
  listMoroHubPerformance: subsidiaryPerformance[];
  listDigitalXPerformance: subsidiaryPerformance[];
  listInfraXPerformance: subsidiaryPerformance[];
  overAllProfit: portfolio;
  moroProfit: portfolio;
  digitalXProfit: portfolio;
  infraXProfit: portfolio;
  selectedQuarterFilter?: string;
}
export class overAllPerformance {
  kpiYearQuarter?: string;
  digitalX?: number;
  infraX?: number;
  moro?: number;
}
export class subsidiaryPerformance {
  slaName?: string;
  isWellPerformed?: number;
  isNotWellPerformed?: number;
  totalKPI?: number;
  totalWellPerformed?: number;
  totalNotWellPerformed?: number;
}
export class portfolio {
  isWellPerformed?: number;
  totalItems?: number;
  percentage?: number;  
}
export class surveyConfig {
  enableSurveyLink?: string;
  surveyLink?: string;
  bmRequestLink?: string;
  userUno?: string;
}

export class actionPlan {
  languageUno?: number;
  condition?: number;
  tenantUno?: number;
  userUno?: string;
  kpiUno?: string;
  actionPlanID?: string;
  actionPlanCode?: string;
  actionPlanBrief?: string;
  completion?: string;
  startDate?: string;
  endDate?: string;
  actionType: string;
  divisionUno?: number;
  yearUno?: number;
  quarterUno?: number;
}

export class actionPlanDetail {
  languageUno?: number;
  condition?: number;
  tenantUno?: number;
  userUno?: string;
  kpiUno?: string;
  actionPlanID?: string;
  actionPlanCode?: string;
  actionPlanBrief?: string;
  completion?: string;
  startDate?: string;
  endDate?: string;
  actionType: string;
  actionPlanName: string;
  accountablity: string;
  comment: string;
  actionPlanDetailID: string;
  accountablityName: string;
}

export class actionPlanDetailHistory {
  languageUno?: number;
  condition?: number;
  tenantUno?: number;
  userUno?: string;
  kpiUno?: string;
  actionPlanHistoryID?: string;
  actionPlanID?: string;
  actionPlanCode?: string;
  actionPlanBrief?: string;
  completion?: string;
  startDate?: string;
  endDate?: string;
  actionType: string;
  actionPlanName: string;
  accountablity: string;
  comment: string;
  actionPlanDetailID: string;
  accountablityName: string;
}
export class importtranbenchmarkkpi {
  year?: number;
  source?: string;
  actual?: string;
  considered_benchmarks?: string;
  constraints?: string;
  filter?: string;
  peers?: string;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;;
  itemUno?: number;
  condition?: number;
  importData: any = [];

}
export class kpidelegate {
  kpiuno: number;
  kpicode: string;
  kpi: string;
  period: string;
  owner: string;
  roletype: string;
  //filter
  userUno: string;
  tenantUno: number;
  languageUno: number;
  condition: number;
  year: number;
  quarter: number;
  checkUserUno: string;
  //insertUpdate
  currentUserUno: string;
  delegationUserUno: string;
  delegationType: string;
  startDate?: Date;
  endDate?: Date;

}
export class kpiDelegateUpdate {
  kpiUno: number;
  userUno: string;
  currentUserUno: string;
  delegatedUserUno: string;
  delegationType: string;
  startDate: Date | null;
  endDate: Date | null;
  tenantUno: number;
  year: number;
  quarter: number;
  // delegate
  kpiDelUno?: number;
  previousUserName?: string;
  delegatedUserName?: string;
  delegatedFromUserName?: string;
  roleType?: string;
  kpiName?: string;
  kpiCode?: string;
  fromDate?: Date | null;
  toDate?: Date | null;
  condition?: number;
  kpisJson?: string;
  openKpiDropdownIndex?: number;
}
